<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card class="delete-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>mdi-alert-circle</v-icon>
        אישור מחיקה
      </v-card-title>
      
      <v-card-text class="delete-content">
        <div class="delete-icon-container">
          <v-icon size="64" color="#f44336">mdi-delete-forever</v-icon>
        </div>
        <p class="delete-message">האם אתה בטוח שברצונך למחוק את הפריט?</p>
        <p class="delete-warning">פעולה זו אינה ניתנת לביטול.</p>
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions class="dialog-actions">
        <v-btn
          color="error"
          class="delete-button"
          @click="actionConfirmed"
          :loading="progressShow"
          :disabled="progressShow"
        >
          <v-icon left>mdi-delete</v-icon>
          אישור מחיקה
        </v-btn>
        <v-btn
          color="grey lighten-3"
          
          @click="closeDelete"
        >
          ביטול
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    item: Object,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),

  methods: {
    actionConfirmed() {
      this.deleteItem();
    },
    async deleteItem() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ item: this.item });

        let api = process.env.VUE_APP_BASE_URL + "/agent_api/delete_record";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", itemsJSON, token));
        if (res.status >= 400) {
          this.$emit("itemDeleted", "", "תקלה במחיקת הקלטה", "red");
          this.progressShow = false;
        } else if (res.status === 200) {
          this.$emit("itemDeleted", this.item._id, "ההקלטה נמחקה בהצלחה!", "green");
          this.progressShow = false;
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.$emit("itemDeleted", "", "תקלה במחיקת הקלטה", "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
  },
}
</script>

<style scoped>
.delete-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #f44336 0%, #e57373 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.delete-content {
  padding: 24px 16px;
  text-align: center;
}

.delete-icon-container {
  margin-bottom: 16px;
}

.delete-message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.delete-warning {
  font-size: 14px;
  color: #f44336;
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: center;
}

.delete-button {
  margin-left: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.delete-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
  }
  
  .delete-button {
    margin-left: 0;
    margin-bottom: 8px;
    width: 100%;
  }
}
</style>